import { History } from "history";

import { getFormType } from "../../components/Form/helpers";

interface CreateStepChangeHandlerParams {
  isExtended: boolean;
  isPersisted: boolean;
  formStepRenderEvent: any;
  history: History;
  formId: string;
}

type CreateStepChangeHandler = (params: CreateStepChangeHandlerParams) => (params: any) => void;

export const createStepChangeHandler: CreateStepChangeHandler = ({
  isExtended,
  isPersisted,
  formStepRenderEvent,
  history,
  formId
}) => (params: any) => {
  const formType = getFormType(isExtended, isPersisted);
  formStepRenderEvent({ ...params, formId, formType });
  const stepManagerProps = params.formProps
    ? params.formProps.stepManagerProps
    : params.stepManagerProps;
  if (stepManagerProps) {
    const { steps, extended } = stepManagerProps;
    const [step] = steps;
    const nextURLHash = extended ? "/extended" : `/${step.id}`;
    return history.push(nextURLHash);
  }
};
